import {Disk, rowsOfDisk} from "../disk-list/core/_models";
import {QueryState, Response} from "../../../../_metronic/helpers";
import {iterator} from "./_helper";



const rowsAddToCash = (object : rowsOfDisk[])=>{
    localStorage.setItem("rows", JSON.stringify(object));
}
const getRowsFromCash=() : rowsOfDisk[] =>{
    const response =   JSON.parse(localStorage.getItem("rows") || "[]") as rowsOfDisk[];
    return response ;
}
const clearRowsCash = ()=>{
    localStorage.removeItem("rows");
}
const diskAddToCash = (object : Disk)=>{
    // localStorage.removeItem("disk");
    localStorage.setItem("disk", JSON.stringify(object));

}
const getDiskFromCash=() : Disk =>{
    const response =   JSON.parse(localStorage.getItem("disk") || "{}") ;
    return response ;
}
const getRowsFromCashByQuery=(request : QueryState) : Response<rowsOfDisk[]> =>{
    let response =   JSON.parse(localStorage.getItem("rows") || "{}") as rowsOfDisk[];
    if (request){
        if (request.search && request.search?.length>0){
            let newRow : rowsOfDisk[]= []
            for (let i = 0; i <response.length ; i++) {
                if (response[i]?.employeeDto?.dsW_FNAME?.includes(request.search) ){
                    newRow.push(response[i])

                }
                if (response[i]?.employeeDto?.dsW_LNAME?.includes(request.search) ){
                    newRow.push(response[i])

                }
                if (response[i]?.employeeDto?.peR_NATCOD?.includes(request.search) ){
                    newRow.push(response[i])

                }
                // if (response[i]?.employeeDto?.dsW_IDPLC?.includes(request.search) ){
                //     newRow.push(response[i])
                //
                // }
                // if (response[i]?.employeeDto?.dsW_IDNO?.includes(request.search) ){
                //     newRow.push(response[i])
                //
                // }
            }
            // @ts-ignore
             response = [...new Set(newRow)]

        }
        // if(request.sort && request.sort?.length>0 ){
        //
        //     // @ts-ignore
        //     response = response.sort((a, b)=>a[request.sort] - b[request.sort] )
        // }
    }

    const skip = (request.page -1 )* (request.items_per_page || 10) ;
    if (response.length > 0){
        const totalPage = Math.ceil(response.length /request.items_per_page )
        let links : Array<{label: string; active: boolean; url: string ; page: number }> = [] ;
        let linkId = Number(request.page) - 1 ;
        for (let i = 0; i < 5 ; i++) {
            if (linkId > 0){
                links.push({
                    page : linkId ,
                    label : linkId.toString() ,
                    url : `/?page=${linkId}`,
                    active : false
                })
                linkId -- ;
            }
        }
        links.push({
            page :  Number(request.page) ,
            label :  request.page.toString() ,
            url : `/?page=${ request.page}`,
            active : true
        })
        let perLink =Number(request.page) + 1 ;
        for (let i = 0; i < 5 ; i++) {
            // console.log(perLink + '=' + totalPage)
            if (perLink <= totalPage ){
                links.push({
                    page : perLink ,
                    label : perLink.toString() ,
                    url : `/?page=${perLink}`,
                    active : false
                })
                perLink ++ ;
            }
        }
        let res : Response<rowsOfDisk[]> = {
            data :   response.slice(skip,Number(skip)+Number(request.items_per_page)),
            payload : {
                pagination : {
                    items_per_page : request.items_per_page ,
                    page : Number(request.page) ,
                    total : response.length,
                    last_page : request.page >1 ? request.page -1 : 1 , links :links.sort((a, b)=>a.page - b.page)
                }
            }

        }
        console.log(Number(skip)+Number(request.items_per_page))
        return res  ;
        // let res : Response<rowsOfDisk[]> ={
        //     data : [],
        //     payload : {
        //         pagination : {
        //             items_per_page :10,
        //             last_page : 0 ,
        //             total : 0 ,
        //             page : 0
        //         }
        //     }
        // }
        // return res
    }
    else {
        let res : Response<rowsOfDisk[]> ={
            data : [],
            payload : {
                pagination : {
                    items_per_page :10,
                    last_page : 0 ,
                    total : 0 ,
                    page : 0
                }
            }
        }
        return res
    }


}


export {diskAddToCash,getDiskFromCash,rowsAddToCash,getRowsFromCash,getRowsFromCashByQuery,clearRowsCash }
